declare namespace $ {

	type $mol_paragraph__title_shm_hitalama_opencode_map_chat_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_chat['no_map_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $shm_hitalama_resizer_side__resize_side_shm_hitalama_opencode_map_chat_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_chat['resize_side'] >
		,
		ReturnType< $shm_hitalama_resizer_side['resize_side'] >
	>
	type $shm_hitalama_resizer_side__width_shm_hitalama_opencode_map_chat_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_chat['width'] >
		,
		ReturnType< $shm_hitalama_resizer_side['width'] >
	>
	type $shm_hitalama_opencode_map_sessions__server_url_shm_hitalama_opencode_map_chat_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_chat['server_url'] >
		,
		ReturnType< $shm_hitalama_opencode_map_sessions['server_url'] >
	>
	type $shm_hitalama_opencode_map_sessions__map_id_shm_hitalama_opencode_map_chat_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_chat['map_id'] >
		,
		ReturnType< $shm_hitalama_opencode_map_sessions['map_id'] >
	>
	type $shm_hitalama_opencode_map_sessions__session_id_shm_hitalama_opencode_map_chat_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_chat['session_id'] >
		,
		ReturnType< $shm_hitalama_opencode_map_sessions['session_id'] >
	>
	type $shm_hitalama_opencode_map_sessions__new_session_model_shm_hitalama_opencode_map_chat_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_opencode_map_chat['new_session_model'] >
		,
		ReturnType< $shm_hitalama_opencode_map_sessions['new_session_model'] >
	>
	type $mol_page__title_shm_hitalama_opencode_map_chat_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_hitalama_opencode_map_chat_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $shm_hitalama_opencode_map_chat extends $shm_hitalama_opencode_session {
		width_px( ): ReturnType< ReturnType< $shm_hitalama_opencode_map_chat['Side_resizer'] >['width_px'] >
		session_id( next?: string ): string
		events_native( ): any
		no_map_text( ): string
		No_map( ): $mol_paragraph
		server_url( next?: string ): string
		map_id( ): string
		resize_side( ): string
		width( next?: number ): number
		thinking_width( ): number
		panel_width_px( ): string
		new_session_model( ): any
		Side_resizer( ): $shm_hitalama_resizer_side
		Map_sessions( ): $shm_hitalama_opencode_map_sessions
		style( ): ({ 
			'width': ReturnType< $shm_hitalama_opencode_map_chat['panel_width_px'] >,
			'flexBasis': ReturnType< $shm_hitalama_opencode_map_chat['panel_width_px'] >,
			'position': string,
		})  & ReturnType< $shm_hitalama_opencode_session['style'] >
		auto( ): readonly(any)[]
		No_map_page( ): $mol_page
	}
	
}

//# sourceMappingURL=chat.view.tree.d.ts.map